import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import { Box, Chip, Tooltip } from '@mui/material';
import {
	safetyCourseStatus,
	SafetyCourseStatus,
} from '../../../../constants/SafetyCourse';
import {
	ExpiredTooltip,
	NotFoundTooltip,
	ValidTooltip,
} from '../SafetyCourseStatusChip/SafetyCourseStatusChip';

export type SafetyCourseStatusIconProps = {
	status: SafetyCourseStatus;
};

export const SafetyCourseStatusIcon = ({
	status,
}: SafetyCourseStatusIconProps): JSX.Element => {
	switch (status) {
		case safetyCourseStatus.Expired:
			return (
				<ExpiredTooltip>
					<Box
						display="flex"
						flexDirection="column"
						alignItems="center">
						<ErrorOutlineOutlinedIcon
							sx={{ fontSize: 64 }}
							color="error"
						/>
						<Chip label="Expired" size="small" color="error" />
					</Box>
				</ExpiredTooltip>
			);
		case safetyCourseStatus.Valid:
			return (
				<ValidTooltip>
					<Box
						display="flex"
						flexDirection="column"
						alignItems="center">
						<CheckCircleOutlineOutlinedIcon
							color="success"
							sx={{ fontSize: 64 }}
						/>
						<Chip
							label="Valid"
							size="small"
							color="success"
							sx={{ width: '100%' }}
						/>
					</Box>
				</ValidTooltip>
			);
		case safetyCourseStatus.NotFound:
			return (
				<NotFoundTooltip>
					<Box
						display="flex"
						flexDirection="column"
						alignItems="center">
						<HelpOutlineOutlinedIcon
							sx={{ fontSize: 64 }}
							color="neutral"
						/>
						<Chip label="Not Found" size="small" color="neutral" />
					</Box>
				</NotFoundTooltip>
			);
		case safetyCourseStatus.Unverified:
			return (
				<Tooltip title="Safety Course Status ">
					<Box
						display="flex"
						flexDirection="column"
						alignItems="center">
						<HelpOutlineOutlinedIcon
							color="secondary"
							sx={{ fontSize: 64 }}
						/>
						<Chip
							label="Unverified"
							size="small"
							color="secondary"
						/>
					</Box>
				</Tooltip>
			);
	}
};
